import { Prompt, promptModels } from '../../../../services/backendService/types';

export const getStudentAnswerTypes = (slideId: string) => [
  {
    responseId: 'i_do_not_know',
    response: '',
    responsePrompt: "I don't know",
    label: "I don't know",
    slideId,
  },
  {
    responseId: 'very_poor',
    response: '',
    responsePrompt: 'Very poor with poor grammar, sentence structure and punctuation',
    label: 'Poor + poor grammar',
    slideId,
  },
  {
    responseId: 'poor',
    response: '',
    responsePrompt: 'Poor',
    label: 'Poor',
    slideId,
  },
  {
    responseId: 'good',
    response: '',
    responsePrompt:
      'Good evidence but with poor grammar, sentence structure and punctuation',
    label: 'Good evidence + poor grammar',
    slideId,
  },
  {
    responseId: 'excellent',
    response: '',
    responsePrompt: 'Excellent all round',
    label: 'Excellent all round',
    slideId,
  },
];

export const SLATE_STUDENT_CATEGORY_INPUT_ID = 'student-category';
export const SLATE_SLIDE_QUESTION_ID = 'slide-question';

export const studentAnswerBasePrompt = [
  {
    type: 'paragraph',
    children: [
      {
        text: 'Based on the context below create an example answer that is considered a ',
        color: '#282F33',
      },
      {
        type: 'livePromptInput',
        inputId: SLATE_STUDENT_CATEGORY_INPUT_ID,
        label: 'Student response category',
        children: [{ text: '' }],
      },
      { text: ' answer to the question: ' },
      {
        type: 'livePromptInput',
        inputId: SLATE_SLIDE_QUESTION_ID,
        label: 'Slide question',
        children: [{ text: '' }],
      },
    ],
    align: 'center',
    size: 80,
  },
  {
    type: 'paragraph',
    align: 'center',
    size: 80,
    children: [
      {
        color: '#282F33',
        text:
          'Include occasional inconsistencies in grammar, sentence structure, punctuation, capitalization and mechanics. Do not include a greeting or analysis of the response in the output.',
      },
    ],
  },
  {
    type: 'paragraph',
    align: 'center',
    size: 80,
    children: [{ color: '#282F33', text: '--- Context start ---' }],
  },
  {
    type: 'paragraph',
    align: 'center',
    size: 80,
    children: [{ color: '#282F33', text: '' }],
  },
  {
    type: 'paragraph',
    align: 'center',
    size: 80,
    children: [{ color: '#282F33', text: '--- Context end ---' }],
  },
];

export const createStudentAnswerPrompt = (promptContent: string): Prompt => ({
  id: 'answerPrompt',
  messages: [{ content: promptContent, role: 'user' }],
  promptOutput: {
    description: 'Student answer',
    properties: {},
    propertiesOrder: undefined,
    resource: {
      model: promptModels.gpt4o,
      type: 'openAi',
    },
    type: 'string',
  },
  temperature: 0.7,
  name: 'Answer Prompt',
});
